import React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import { PATH } from 'shared/constants';
import iconClose from 'assets/icons/iconTopbarClose.png';
import {
  InvestorProfile,
  JourneyOverview,
  RiskAssessment,
  InvestmentPreference,
  InvestmentSummary,
  ProductRecommendation,
  FundFactsheets,
  AssetsAllocation,
  CallToAction,
  ThankYou,
  GoalSummary,
  Homepage,
  AboutInvestmentAdvice,
  Language,
  Welcome,
} from 'pages';

const Routes = ({ history }) => (
  <Switch>
    <Route
      path={PATH.CALL_TO_ACTION}
      render={props => <CallToAction {...props} />}
    />
    <Route
      path={PATH.THANK_YOU}
      render={props => (
        <ThankYou
          {...props}
          navTitle="thankYou.allDone"
          rightButton={(<img src={iconClose} alt="X" />)}
          onRightClick={() => history.push(PATH.JOURNEY_OVERVIEW)}
        />
      )
      }
    />
    <Route
      path={PATH.INVESTOR_PROFILE}
      render={props => <InvestorProfile {...props} />}
    />
    <Route
      path={PATH.RISK_ASSESSMENT}
      render={props => <RiskAssessment {...props} navTitle="risk.title" />}
    />
    <Route
      path={PATH.INVESTMENT_PREFERENCE}
      render={props => <InvestmentPreference {...props} navTitle="investmentPreference.title" />}
    />
    <Route
      path={PATH.INVESTMENT_SUMMARY}
      render={props => <InvestmentSummary {...props} />}
    />
    <Route
      path={PATH.PRODUCT_RECOMMENDATION}
      render={props => <ProductRecommendation {...props} />}
    />
    <Route
      path={PATH.FUND_FACTSHEET}
      render={props => <FundFactsheets {...props} />}
    />
    <Route
      path={PATH.ASSETS_ALLOCATION}
      render={props => <AssetsAllocation {...props} />}
    />
    <Route
      path={PATH.GOAL_SUMMARY}
      render={props => <GoalSummary {...props} />}
    />
    <Route
      path={PATH.JOURNEY_OVERVIEW}
      render={props => <JourneyOverview {...props} />}
    />
    <Route
      path={PATH.ABOUT_INVESTMENT_ADVICE}
      render={props => (
        <AboutInvestmentAdvice
          {...props}
          navTitle="aboutInvestmentAdvice.title"
          rightButton={(<img src={iconClose} alt="X" />)}
          onRightClick={() => props.history.goBack()}
        />
      )}
    />
    <Route
      path={PATH.WELCOME}
      render={props => <Welcome {...props} />}
    />
    <Route
      path={PATH.HOME}
      render={props => <Homepage {...props} />}
    />
    <Route
      path={PATH.LANGUAGE}
      render={props => <Language {...props} />}
    />
  </Switch>
);

export default withRouter(Routes);
